import { FETCH_INTRODUCER_CODE } from '../constants/introducer_code';

export function fetchIntroducerCode(text) {
  return {
    type: FETCH_INTRODUCER_CODE,
    api: true,
    // auth:null means auth:true for authenticated user and auth:false for non authenticated user
    auth: null,
    payload: {
      method: 'GET',
      url: `/introducers/codes/${text}`
    }
  };
}
